import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const DatePickerController = ({
  name,
  format = "DD/MM/yyyy",
  errors,
  required,
  label,
  disablePast = false,
  disabled = false,
  extraRules,
  control,
}) => {
  const scontrol = useFormContext();
  const mcontrol = control || scontrol;
  return (
    <FormControl style={{ minWidth: 400 }}>
      <Controller
        name={name}
        control={mcontrol}
        rules={{
          required: {
            value: !!required,
            message: `${name} is required.`,
          },
          ...extraRules,
        }}
        render={({ field: { ref, ...rest } }) => (
          <DatePicker
            disablePast={disablePast}
            disabled={disabled}
            label={label}
            format={format}
            slotProps={{
              textField: {
                margin: "normal",
                id: "date-picker-dialog",
              },
              actionBar: {
                "aria-label": "change date",
              },
            }}
            {...rest}
          />
        )}
      />
      <p style={{ color: "red" }}>{errors[name]?.message}</p>
    </FormControl>
  );
};

export default DatePickerController;
